export default class UserGroupModel {
  constructor () {
    this.groupName = null
    this.checked = true
    this.permission = 0x0
  }
}
